import { Groups } from "@mui/icons-material";
import { Link, TextField, Typography } from "@mui/material";
import { useState } from "react";
import { ItemProperty } from "src/components";
import { Links } from "../../constants";
import { IssueDto, useEditIssueTeam, useGetTeams } from "../../http";
import { ITeamSummary } from "../../models";
import { Autocomplete } from "../Autocomplete";

interface IProps {
  issue: IssueDto;
  onTeamChanged?: (team: ITeamSummary | null) => void;
}

const IssueTeamProperty = (props: IProps) => {
  const { isLoading: isLoadingTeams, data: teams } = useGetTeams();
  const { mutateAsync, isLoading: isEditingIssue } = useEditIssueTeam();
  const [isEditing, setIsEditing] = useState(false);

  async function handleTeamChanged(teamSlug: string | null) {
    const newTeam = teams?.find((x) => x.slug === teamSlug);

    await mutateAsync({
      issueGuid: props.issue.guid,
      oldTeamSlug: props.issue.assignedTeam?.slug,
      newTeamSlug: newTeam?.slug,
      newTeamName: newTeam?.name,
      createdByUserId: props.issue.createdByUser.userId,
    });

    setIsEditing(false);
    props.onTeamChanged?.(newTeam ?? null);
  }

  return (
    <ItemProperty
      labelIcon={<Groups />}
      label="Team"
      canEdit={props.issue.userCanEditOtherProperties}
      isEditing={isEditing}
      onEditClicked={() => setIsEditing(true)}
    >
      {isEditing ? (
        <Autocomplete
          isLoading={isLoadingTeams}
          disabled={isLoadingTeams || isEditingIssue}
          options={teams?.map((x) => x.slug) ?? []}
          getOptionLabel={(option) => teams?.find((x) => x.slug === option)?.name ?? ""}
          onChange={(_, option) => handleTeamChanged(option)}
          renderInput={(params) => (
            <TextField {...params} placeholder="Select a team..." inputProps={{ ...params.inputProps }} />
          )}
          value={props.issue.assignedTeam?.slug ?? null}
        />
      ) : props.issue.assignedTeam ? (
        <Link
          noWrap
          onClick={(e) => e.stopPropagation()}
          href={Links.TeamImplementation(props.issue.assignedTeam.slug)}
        >
          {props.issue.assignedTeam.name}
        </Link>
      ) : (
        <Typography>No team assigned</Typography>
      )}
    </ItemProperty>
  );
};

export { IssueTeamProperty };
